import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import ordersReducer from 'src/reducers/ordersReducer';
import followUpReducer from 'src/reducers/followUpReducer';
import notificationReducer from 'src/reducers/notificationReducer';
import accountReducer from 'src/reducers/accountReducer';
import accountSettingsReducer from 'src/reducers/accountSettingsReducer';
import birthdayMessageReducer from 'src/reducers/birthdayMessageReducer';
import notificationsReducer from 'src/reducers/notificationsReducer';
import chatReducer from 'src/reducers/chatReducer';
import shortCodeReducer from 'src/reducers/shortCodeReducer';
import mailReducer from 'src/reducers/mailReducer';
import kanbanReducer from 'src/reducers/kanbanReducer';
import messagesReducer from 'src/reducers/messagesReducer';
import scheduledMessagesReducer from 'src/reducers/scheduledMessagesReducer';
import scheduledMessagesDetailsReducer from 'src/reducers/scheduledMessagesDetailsReducer';
import subscriptionsReducer from 'src/reducers/subscriptionsReducer';
import scrollReducer from 'src/reducers/scrollReducer';
import customersReducer from 'src/reducers/customersReducer';
import customerDetailsReducer from 'src/reducers/customerDetailsReducer';
import customerCategoriesReducer from 'src/reducers/customerCategoriesReducer';
import partiesReducer from 'src/reducers/partiesReducer';
import partyDetailsReducer from 'src/reducers/partyDetailsReducer';
import partySettingsReducer from 'src/reducers/partySettingsReducer';
import partyVenuesReducer from 'src/reducers/partyVenuesReducer';
import partyVenueDetailsReducer from 'src/reducers/partyVenueDetailsReducer';
import partyTypesReducer from 'src/reducers/partyTypesReducer';
import partyTypeDetailsReducer from 'src/reducers/partyTypeDetailsReducer';
import orderSettingsReducer from 'src/reducers/orderSettingsReducer';
import orderFollowUpDetailsReducer from 'src/reducers/orderFollowUpDetailsReducer';
import orderDetailsReducer from 'src/reducers/orderDetailsReducer';
import smartActionGroupsReducer from 'src/reducers/smartActionGroupsReducer';
import smartActionsReducer from 'src/reducers/smartActionsReducer';
import smartActionDetailsReducer from 'src/reducers/smartActionDetailsReducer';
// import scheduledSmartActionGroupsReducer from 'src/reducers/scheduledSmartActionGroupsReducer';
import scheduledSmartActionsReducer from 'src/reducers/scheduledSmartActionsReducer';
import scheduledSmartActionDetailsReducer from 'src/reducers/scheduledSmartActionDetailsReducer';
import formsReducer from 'src/reducers/formsReducer';
import formDefinitionReducer from 'src/reducers/formDefinitionReducer';
import formDefinitionDetailsReducer from 'src/reducers/formDefinitionDetailsReducer';
import formPartyJoinReducer from 'src/reducers/formPartyJoinReducer';
import formPartyJoinDetailsReducer from 'src/reducers/formPartyJoinDetailsReducer';
import signupReducer from 'src/reducers/signupReducer';
import contactSettingsReducer from 'src/reducers/contactSettingsReducer';
import messagingSettingsReducer from 'src/reducers/messagingSettingsReducer';
import textingOptInReducer from 'src/reducers/textingOptInReducer';
import groupSettingsReducer from 'src/reducers/groupSettingsReducer';
import groupTypeDetailsReducer from 'src/reducers/groupTypeDetailsReducer';
import groupsReducer from 'src/reducers/groupsReducer';
import groupDetailsReducer from 'src/reducers/groupDetailsReducer';
import formGroupJoinReducer from 'src/reducers/formGroupJoinReducer';
import formGroupJoinDetailsReducer from 'src/reducers/formGroupJoinDetailsReducer';
import groupSmartActionsReducer from 'src/reducers/groupSmartActionsReducer';
import groupSmartActionDetailsReducer from 'src/reducers/groupSmartActionDetailsReducer';
import smartFieldsReducer from 'src/reducers/smartFieldsReducer';
import smartLinksReducer from 'src/reducers/smartLinksReducer';
import shareCenterReducer from 'src/reducers/shareCenterReducer';
import smartFormsReducer from 'src/reducers/smartFormsReducer';
import valueListsReducer from 'src/reducers/valueListsReducer';
import eventTemplatesReducer from 'src/reducers/eventTemplatesReducer';
import eventTemplateAdminReducer from 'src/reducers/eventTemplateAdminReducer';
import tcrPortAdminReducer from 'src/reducers/tcrPortAdminReducer';
import eventTemplateTypesReducer from 'src/reducers/eventTemplateTypesReducer';
import templateCategoriesReducer from 'src/reducers/templateCategoriesReducer';
import pageColumnDefaultsAdminReducer from 'src/reducers/pageColumnDefaultsAdminReducer';
import setupAssistantReducer from 'src/reducers/setupAssistantReducer';
import activityReducer from 'src/reducers/activityReducer';

const rootReducer = combineReducers({
  account: accountReducer,
  accountSettings: accountSettingsReducer,
  birthdayMessage: birthdayMessageReducer,
  partySettings: partySettingsReducer,
  orderSettings: orderSettingsReducer,
  orderFollowUpDetails: orderFollowUpDetailsReducer,
  notifications: notificationsReducer,
  notification: notificationReducer,
  chat: chatReducer,
  shortCodes: shortCodeReducer,
  mail: mailReducer,
  kanban: kanbanReducer,
  form: formReducer,
  orders: ordersReducer,
  orderDetails: orderDetailsReducer,
  followUp: followUpReducer,
  messages: messagesReducer,
  subscriptions: subscriptionsReducer,
  scroll: scrollReducer,
  customers: customersReducer,
  customerDetails: customerDetailsReducer,
  customerCategories: customerCategoriesReducer,
  parties: partiesReducer,
  partyDetails: partyDetailsReducer,
  partyVenues: partyVenuesReducer,
  partyVenueDetails: partyVenueDetailsReducer,
  partyTypes: partyTypesReducer,
  partyTypeDetails: partyTypeDetailsReducer,
  smartActionGroups: smartActionGroupsReducer,
  smartActions: smartActionsReducer,
  smartActionDetails: smartActionDetailsReducer,
  // scheduledSmartActionGroups: scheduledSmartActionGroupsReducer,
  scheduledSmartActions: scheduledSmartActionsReducer,
  scheduledSmartActionDetails: scheduledSmartActionDetailsReducer,
  forms: formsReducer,
  formDefinition: formDefinitionReducer,
  formDefinitionDetails: formDefinitionDetailsReducer,
  formPartyJoin: formPartyJoinReducer,
  formPartyJoinDetails: formPartyJoinDetailsReducer,
  signup: signupReducer,
  contactSettings: contactSettingsReducer,
  scheduledMessages: scheduledMessagesReducer,
  scheduledMessagesDetails: scheduledMessagesDetailsReducer,
  messagingSettings: messagingSettingsReducer,
  textingOptIn: textingOptInReducer,
  groupSettings: groupSettingsReducer,
  groupTypeDetails: groupTypeDetailsReducer,
  groups: groupsReducer,
  groupDetails: groupDetailsReducer,
  formGroupJoin: formGroupJoinReducer,
  formGroupJoinDetails: formGroupJoinDetailsReducer,
  groupSmartActions: groupSmartActionsReducer,
  groupSmartActionDetails: groupSmartActionDetailsReducer,
  smartFields: smartFieldsReducer,
  smartLinks: smartLinksReducer,
  shareCenter: shareCenterReducer,
  smartForms: smartFormsReducer,
  valueLists: valueListsReducer,
  eventTemplates: eventTemplatesReducer,
  eventTemplateAdmin: eventTemplateAdminReducer,
  tcrPortAdmin: tcrPortAdminReducer,
  eventTemplateTypes: eventTemplateTypesReducer,
  templateCategories: templateCategoriesReducer,
  pageColumnDefaultsAdmin: pageColumnDefaultsAdminReducer,
  setupAssistant: setupAssistantReducer,
  activity: activityReducer,

});

export default rootReducer;
